import { render, staticRenderFns } from "./DataText.vue?vue&type=template&id=8f8d9aae&"
import script from "./DataText.vue?vue&type=script&lang=js&"
export * from "./DataText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports